export default __webpack_public_path__ + "static/bankless-c61ee9d341de0e249e64860c5f2fb94b.png";